<carousel [noPause]="false" [isAnimated]="true">
	<slide>
		<img
			src="../../assets/images/family1.jpg"
			style="display: block; height: 70rem; width: 100%"
		/>
		<div class="carousel-caption d-none d-md-block">
			<h3>Loving Dad</h3>
			<p style="color: white; font-size: larger; font-weight: 500">
				Family comes first, I love my family!
			</p>
		</div>
	</slide>
	<slide>
		<div
			class="text-center bg-dark text-white"
			style="
				height: 70rem;
				justify-content: center;
				background-image: url(../../assets/images/icons/angular-logo.png);
				background-repeat: no-repeat;
				background-position: center;
			"
		>
			<div class="d=flex" style="height: 25%"></div>
			<div class="d=flex" style="height: 25%"><h2>Resume</h2></div>
			<div class="d=flex" style="height: 25%"></div>
			<div class="d=flex" style="height: 25%">
				<div class="lead">
					<h3>This online resume is written in Angular</h3>
					<p>Ngx Bootstrap and ChartJS as well</p>
				</div>
			</div>
		</div>
	</slide>
	<slide>
		<div
			class="text-center bg-dark text-white"
			style="
				height: 70rem;
				justify-content: center;
				background-image: url(../../assets/images/icons/reactjs-logo.png);
				background-repeat: no-repeat;
				background-position: center;
			"
		>
			<div class="d=flex" style="height: 25%"></div>
			<div class="d=flex" style="height: 25%">
				<h2>Sample React Project</h2>
			</div>
			<div class="d=flex" style="height: 25%"></div>
			<div class="d=flex" style="height: 25%">
				<div class="lead">
					<h3>Puzzle Solver</h3>
					<p>
						Demonstrates knowledge of graph thoery
						<a href="https://puzzle-solver.onrender.com">Try me</a>
					</p>
				</div>
			</div>
		</div>
	</slide>
</carousel>
